import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {AlertFeedbackModel} from "../_models/AlertFeedbackModel";
import {IController} from "../../../controllers/IController";

export const IT_ALERT_FEEDBACK_CONTROLLER = new InjectionToken<IAlertFeedbackController>('IT_ALERT_FEEDBACK_CONTROLLER');
export const MK_ALERT_FEEDBACK = new ModelKey<AlertFeedbackModel>('MK_ALERT_FEEDBACK');

export interface IAlertFeedbackController extends IController {

}
